/** Result of charging a saved card / bank account when sending an invoice. */
export type ChargeOnSendResult =
  | {
      status: "succeeded";
      amount: number;
      payment_intent_id: string;
      method: string;
    }
  | {
      status: "processing";
      amount: number;
      payment_intent_id: string;
      method: string;
    }
  | { status: "failed"; message: string; method: string | null };

/** A card or bank account the client has on file. */
export type SavedClientPaymentMethod = {
  id: string;
  type: "card" | "us_bank_account";
  brand: string | null;
  last4: string | null;
  bank_name: string | null;
  exp_month: number | null;
  exp_year: number | null;
  authorized: boolean;
  is_default: boolean;
};

/** "Visa ····4242" / "Chase ····6789". */
export const chargeMethodTitle = (method: SavedClientPaymentMethod) =>
  method.type === "us_bank_account"
    ? `${method.bank_name ?? "Bank account"} ····${method.last4 ?? ""}`
    : `${(method.brand ?? "Card").replace(/^./, (c) => c.toUpperCase())} ····${method.last4 ?? ""}`;
